module.exports = __webpack_public_path__ + "static/media/criminal_law_specialist_logo.3b245ae7.png";